import { MENTION_NODE_NAME } from "../extensions/Mention";

import type { MentionNodeAttrs } from "../extensions/Mention";
import type { Node as PMNode } from "@tiptap/pm/model";

export type CollectedMention = {
  /** The mention node id, stable across undo/redo. */
  sourceNodeId: string;
  /** `users.uid` — the client never sees the numeric id. */
  userUid: string;
};

/**
 * Collects every mention in a document or message body.
 *
 * Deduplicated by node id: copying a mention chip duplicates its id, and the id is what the
 * backend upserts on, so reporting it twice is not something the server can make sense of.
 *
 * The Y.js counterpart in apps/yjs-api walks a Y.Doc instead, because the document save path
 * never builds a ProseMirror tree.
 */
export function collectMentions(doc: PMNode): CollectedMention[] {
  const seen = new Set<string>();
  const mentions: CollectedMention[] = [];

  doc.descendants((node) => {
    if (node.type.name !== MENTION_NODE_NAME) return true;

    const { id, userId } = node.attrs as MentionNodeAttrs;
    if (!id || !userId || seen.has(id)) return false;

    seen.add(id);
    mentions.push({ sourceNodeId: id, userUid: userId });

    return false;
  });

  return mentions;
}
